module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-1-9bd19c0dedebaaa00d43c80ad7828be7.jpg";